import { DASHBOARD_LINK } from '@components/Router/constants'
import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import type { Workspace } from '@store/reducers/dashboard/types'
import { SubscriptionActions } from '@store/reducers/subscription'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { selectIsLoading } from '@/store'
import { DashboardActions } from '@/store/reducers/dashboard/actions'
import { useDefaultWorkspaceRedirect } from './useDefaultWorkspaceRedirect'
import { useSaveLastWorkspace } from './useSaveLastWorkspace'

export const useWorkspacesRoot = (
  current: Workspace | null,
  workspaces: Workspace[]
) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const loadingProcess = useSelector(selectIsLoading('workspaces'))

  // todo: fix init workspaces to avoid initial loaded state
  const loading = loadingProcess || workspaces.length === 0

  const { redirecting } = useDefaultWorkspaceRedirect(workspaces, loading)

  useSaveLastWorkspace(current)

  useEffect(() => {
    dispatch(DashboardActions.init())
    dispatch(SubscriptionActions.fetch())
  }, [])

  useEffect(() => {
    if (current || loading) {
      return
    }

    navigate(`${DASHBOARD_LINK}/${PERSONAL_WORKSPACE_ID}`)
    dispatch(ErrorNotification('Requested workspace not found'))
  }, [current, loading])

  return { loading: loading || redirecting }
}
